import image1 from "../../Assets/cashew/cashewkernel2.webp";
import image2 from "../../Assets/Cocoa/cocoa seed2.jpeg";
import image3 from "../../Assets/Charcoal/charcoal2.jpg";
import image4 from "../../Assets/Seasame/White Sesame seed.jpeg";
import image6 from "../../Assets/Other-product/ginger.jpeg";
import image7 from "../../Assets/Other-product/dry corn.jpeg";
import image8 from "../../Assets/Other-product/hibiscus flower.jpeg";
import image9 from "../../Assets/Other-product/coffee beans.webp";

const data = [
  {
    id: 1,
    name: "Cashew Nuts",
    Image: image1,
    link: "/cashew",
  },
  {
    id: 2,
    name: "Cocoa Seeds",
    Image: image2,
    link: "/cocoa",
  },
  {
    id: 3,
    name: "Charcoal",
    Image: image3,
    link: "/charcoal",
  },
  {
    id: 4,
    name: "Seasame",
    Image: image4,
    link: "/seasame",
  },
  {
    id: 5,
    name: "Shea Butter",
    Image:
      "https://149520306.v2.pressablecdn.com/wp-content/uploads/2019/06/Shea-butter.jpeg",
    link: "/sheaButter",
  },
  {
    id: 6,
    name: "Ginger",
    Image: image6,
    link: "/ginger",
  },
  {
    id: 7,
    name: "Dry Corn",
    Image: image7,
  },
  {
    id: 8,
    name: "Harbiscus Flower",
    Image: image8,
  },
  {
    id: 9,
    name: "Coffee Bean",
    Image: image9,
  },
];

export default data;
